import { render } from "./NFTGrid2.vue?vue&type=template&id=521760aa&scoped=true&ts=true"
import script from "./NFTGrid2.vue?vue&type=script&lang=ts"
export * from "./NFTGrid2.vue?vue&type=script&lang=ts"

import "./NFTGrid2.vue?vue&type=style&index=0&id=521760aa&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-521760aa"]])

export default __exports__